/* ════════════════════════════════════════════════════════════════════
   하단 고정 구매 바 — 모바일 전용 (카페24 skin148 이식)

   본문 구매 버튼이 화면을 벗어나면 바가 올라온다. 클릭은 **본문 버튼에 위임**한다 —
   담기 로직을 두 벌 만들면 조용히 갈린다(카페24에서도 같은 원칙).
   ════════════════════════════════════════════════════════════════════ */
(() => {
  "use strict";

  const MOBILE_QUERY = "(max-width: 1024px)";
  /* 런처 윗변이 바 위 이 간격에 오게 한다. */
  const LAUNCHER_GAP = 17;

  const rootElm = document.documentElement;
  const barElm = document.querySelector("[data-nt-sticky]");
  if (!barElm) return;

  const btnElm = barElm.querySelector("[data-nt-sticky-btn]");
  const sectionId = barElm.getAttribute("data-section-id");

  /* 본문의 진짜 버튼들. 이 중 하나의 부모(액션 박스)가 화면을 벗어났는지로 판정한다. */
  const realCart = document.getElementById("ProductSubmitButton-" + sectionId);
  const realBuy = document.getElementById("ProductBuyNowButton-" + sectionId);
  const anchorElm = (realCart || realBuy) && (realCart || realBuy).closest(".product-form__buttons");
  if (!anchorElm) return;

  const mediaList = window.matchMedia(MOBILE_QUERY);
  const show = (on) => rootElm.classList.toggle("nt-sticky-on", on);

  /* ── 바 높이 실측 ────────────────────────────────────────────────
     body 여백이 이 값을 쓴다. 문구·아이콘이 바뀌면 높이도 바뀌므로 고정값을 쓰지 않는다. */
  const measureBar = () => {
    const h = Math.round(barElm.getBoundingClientRect().height);
    if (h > 0) rootElm.style.setProperty("--nt-sticky-h", h + "px");
    return h;
  };

  /* ── 채널톡 런처를 바 위로 올릴 양 계산 ──────────────────────────
     ⚠️ 바 높이를 그대로 올리는 양으로 쓰면 안 된다. 바 패딩에
        `env(safe-area-inset-bottom)` 이 들어 있고 iOS 는 런처의 `bottom` 에도 그 값을
        포함시킬 수 있어 **safe-area 가 두 번 반영**된다 — 카페24에서 실제로 두 버튼이
        바에서 그만큼 더 떠 보였다(2026-08-25 제보).
        런처의 실제 위치를 재서 "바 위 LAUNCHER_GAP" 이 되는 이동량을 직접 구하면
        safe-area 값을 몰라도 정확하다.
     ⚠️ 런처는 **열린 shadow DOM** 안에 있고 클래스명은 배포마다 바뀐다
        (styled-components 해시). `position: fixed` 인 자식으로 **구조로** 찾는다. */
  const chLauncher = () => {
    const entry = document.getElementById("ch-plugin-entry");
    const host = entry && entry.firstElementChild;
    if (!host || !host.shadowRoot) return null;
    const wrap = host.shadowRoot.getElementById("ch-shadow-root-wrapper");
    if (!wrap) return null;
    return (
      Array.prototype.find.call(
        wrap.children,
        (el) => window.getComputedStyle(el).position === "fixed"
      ) || null
    );
  };

  /* ── 런처를 shadow 안에서 옮긴다 ───────────────────────────────
     ⚠️ 문서 스타일시트는 shadow 내부에 닿지 않는다. shadow **host** 에 transform 을 걸면
        내부 `fixed` 요소의 기준이 host 로 바뀌어 런처가 화면 밖으로 날아간다(실측).
        shadow 안에 `<style>` 을 넣는 것이 유일한 방법이다.
     ⚠️ custom property 는 shadow 경계를 **넘어 상속**되므로 바깥의 `--nt-lift` 를 그대로 읽는다.
        `:host-context()` 는 Firefox·Safari 가 지원하지 않아 못 쓴다.
     ⚠️ 클래스로 찾지 않는다 — styled-components 해시라 배포마다 바뀐다. */
  const CH_STYLE_ID = "nt-ch-launcher-offset";

  const injectChStyle = () => {
    const launcher = chLauncher();
    if (!launcher) return false;
    const shadow = launcher.getRootNode();
    if (!shadow || shadow.getElementById(CH_STYLE_ID)) return true;
    const style = document.createElement("style");
    style.id = CH_STYLE_ID;
    style.textContent =
      "#ch-shadow-root-wrapper > div{" +
      "transform:translateY(calc(-1 * var(--nt-lift, 0px))) !important;" +
      "transition:transform .22s cubic-bezier(.2,0,.2,1);" +
      "}";
    shadow.appendChild(style);
    return true;
  };

  /* 채널톡은 늦게 붙는다. 잠깐 재시도하고 포기한다 — 못 찾아도 바 자체는 동작한다. */
  const setupChLauncher = () => {
    let tries = 0;
    const tick = () => {
      if (injectChStyle() || ++tries > 20) return;
      window.setTimeout(tick, 500);
    };
    tick();
  };

  const measureLift = (barH) => {
    const launcher = chLauncher();
    if (!launcher) {
      /* 런처를 못 찾으면(늦게 붙거나 iframe 방식) 바 높이를 쓴다 — 겹치지는 않는다. */
      rootElm.style.setProperty("--nt-lift-on", barH + "px");
      return;
    }
    const cs = window.getComputedStyle(launcher);
    const bottom = parseFloat(cs.bottom) || 0;
    const lift = Math.max(0, Math.round(barH + LAUNCHER_GAP - bottom));
    rootElm.style.setProperty("--nt-lift-on", lift + "px");
  };

  /* ── 표시 판정 ──────────────────────────────────────────────────
     IntersectionObserver 로 액션 박스를 관찰한다. 스크롤마다 레이아웃을 재지 않는다. */
  const evaluate = () => {
    if (!mediaList.matches) {
      show(false);
      return;
    }
    /* 액션 박스가 화면 위로 완전히 지나갔으면 바를 올린다. */
    show(anchorElm.getBoundingClientRect().bottom < 0);
  };

  const refresh = () => {
    const h = measureBar();
    measureLift(h);
    evaluate();
  };

  let observer = null;
  const startObserving = () => {
    if (observer) return;
    observer = new IntersectionObserver(() => evaluate(), { threshold: 0 });
    observer.observe(anchorElm);
  };
  const stopObserving = () => {
    if (!observer) return;
    observer.disconnect();
    observer = null;
  };

  const applyMedia = () => {
    if (mediaList.matches) {
      startObserving();
      refresh();
    } else {
      stopObserving();
      show(false);
    }
  };

  /* Safari 구버전은 addEventListener 를 지원하지 않아 addListener 로 떨어진다. */
  if (typeof mediaList.addEventListener === "function") {
    mediaList.addEventListener("change", applyMedia);
  } else if (typeof mediaList.addListener === "function") {
    mediaList.addListener(applyMedia);
  }

  window.addEventListener("resize", refresh);
  window.addEventListener("orientationchange", refresh);
  /* ⚠️ iOS 인앱은 스크롤 방향에 따라 툴바가 접히며 뷰포트·safe-area 가 바뀐다. 그때
     런처는 CSS 로 따라가지만 계산값이 옛 값에 묶여 있으면 간격이 벌어진다.
     `window.resize` 가 안 오는 경우가 있어 `visualViewport` 도 듣는다. */
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", refresh);
    window.visualViewport.addEventListener("scroll", refresh);
  }

  /* ── 클릭 위임 ─────────────────────────────────────────────────
     ⚠️ 옵션이 안 골라졌으면 담기지 않고 옵션 영역으로 스크롤한다 — 카페24와 같은 동작.
        본문 버튼을 그냥 누르면 브라우저 검증이 화면 밖에서 일어나 아무 일도 없어 보인다. */
  if (btnElm) {
    btnElm.addEventListener("click", () => {
      if (btnElm.disabled) return;

      const picker = document.querySelector("variant-selects, variant-radios, .product-form__input");
      const form = document.getElementById("product-form-" + sectionId);

      if (form && typeof form.reportValidity === "function" && !form.reportValidity()) {
        if (picker) picker.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      const target = btnElm.getAttribute("data-nt-sticky-mode") === "buy"
        ? (realBuy || realCart)
        : (realCart || realBuy);
      if (target) target.click();
    });

    /* 무료배송 조건이면 Buy Now 를 누른다 — 화면에 보이는 버튼과 같은 걸 눌러야 한다.
       ⚠️ 판정을 다시 하지 않는다. `<html class="nt-fs-on">` 이 단일 출처이고
          그건 서버(layout/theme.liquid)가 정한다. CSS 도 같은 클래스를 본다.
       ⚠️ 품절이면 바꾸지 않는다 — 라벨이 "Sold out" 이라 대상이 Buy Now 면 어긋난다. */
    if (
      document.documentElement.classList.contains("nt-fs-on") &&
      !barElm.hasAttribute("data-nt-sticky-sold")
    ) {
      btnElm.setAttribute("data-nt-sticky-mode", "buy");
    }
  }

  /* ⚠️ **스크롤 복원 뒤에는 IO 가 침묵한다.** 새로고침하면 브라우저가 스크롤을 복원하는데,
     IntersectionObserver 는 교차 상태가 **변할 때만** 콜백을 준다. 초기 관찰과 복원 뒤가
     모두 "안 겹침" 이면 변화가 없어 콜백이 오지 않는다 — 페이지 중간에서 새로고침하면
     바가 올라오지 않는다(카페24에서 실측). `pageshow` 도 함께 듣는다(bfcache 복귀).
     ⚠️ 이 리스너들을 지우지 말 것. IO 만으로는 이 상태를 잡을 수 없다. */
  applyMedia();
  setupChLauncher();
  if (document.readyState === "complete") {
    refresh();
  } else {
    window.addEventListener("load", refresh);
  }
  window.addEventListener("pageshow", refresh);

  /* 브라우저의 스크롤 복원이 이 스크립트보다 늦을 수 있다. 몇 지점만 더 확인한다. */
  [100, 300, 700, 1200].forEach((d) => window.setTimeout(refresh, d));
})();
